import { render } from "./chart.vue?vue&type=template&id=2acca3fc&scoped=true"
import script from "./chart.vue?vue&type=script&lang=js"
export * from "./chart.vue?vue&type=script&lang=js"

import "./chart.vue?vue&type=style&index=0&id=2acca3fc&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acca3fc"]])

export default __exports__